import RequestManager from "../../../../requests/RequestManager";
import StatisticsCountryDetailsTask from "src/requests/tasks/sports/CountryDetails/statisticsCountryDetailsTask";
import Translator from "../../../../requests/apa/Translator";
import Utils from "../../../../utils/Utils";
import logger from 'src/utils/logger/logger';

export const getLineupsCountryDetails = async (idLeague, teamViewParam, teamId) => {
	try {
		const statisticsCountryDetailsTask = new StatisticsCountryDetailsTask(idLeague, teamViewParam, teamId);
		const { response } = await RequestManager.addRequest(statisticsCountryDetailsTask);
		if(!response) return [];

		const { teamStatistics: { lineups, teamCard: { team } } } = response || {};
		const coach = lineups && lineups[0] && lineups[0]['coach'];
		const defenders = lineups && lineups[0] && lineups[0]['defenders'];
		const forwards = lineups && lineups[0] && lineups[0]['forwards'];
		const goalkeeper = lineups && lineups[0] && lineups[0]['goalkeeper'];
		const lastLineup = lineups && lineups[0] && lineups[0]['lastLineup'];
		const midfielders = lineups && lineups[0] && lineups[0]['midfielders'];

		const dataLineups = { coach, defenders, forwards, goalkeeper, lastLineup, midfielders };

		return { dataLineups, team };
	} catch (error) {
		logger.error('Error getting statistics country details:', error);
		// return { countries: [], tabs: [] };
	}


}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/CountryDetailsServices/getLineupsCountryDetails.js